import React from 'react';
import classnames from 'classnames';
import {useCompleteInspectionContext} from '../../CompleteInspectionContext';
import styles from './styles.module.scss';
import {getBreakLinesTextShumaType3} from "../../../utils/texts";

const Section8Text12 = React.forwardRef(({}, ref) => {
  const context = useCompleteInspectionContext();
  const {identifyMethodType, warningNote, warningNoteText} = context.data.pdfData;

  return (
    <div ref={ref}>
      {warningNote && warningNoteText && identifyMethodType === 1 && (
        <div className={classnames(styles.itemText, styles.innerPadding)}>
          <span className={classnames(styles.bold, styles.itemNumber)}>-   </span>
          <span className={styles.bold}>הערות בנסח הרישום - </span>
          <span>{getBreakLinesTextShumaType3(warningNoteText)}</span>
        </div>
      )}
    </div>
  );
});

export default Section8Text12;
